import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './tabs.css'

const Tabs = ({ active, items, onChange }) => (
  <div styleName="tabs">
    <ul styleName="list">
      {items.map((item, index) => (
        <li
          key={index}
          styleName={active === index ? 'item-active' : 'item-inactive'}
          onClick={() => onChange(index)}
        >
          {item}
        </li>
      ))}
    </ul>
  </div>
)

Tabs.propTypes = {
  active: PropTypes.number,
  items: PropTypes.array,
  onChange: PropTypes.func,
}

export default CSSModules(Tabs, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/tabs/tabs.js
 **/